// extracted by mini-css-extract-plugin
export default {"valueWrapper":"SelectorButton_valueWrapper__Z3BDd","label":"SelectorButton_label__byxBD"};